
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRainShowersPolartwilightColour as ObiLightRainShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-rain-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightRainShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-light-rain-showers-polartwilight-colour',
   elementClass: ObiLightRainShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 